module.exports = {
	"description": "Dropdown provides a transitory list of actions that appears upon user interaction with a trigger.",
	"methods": [
		{
			"name": "getTriggerProps",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "props",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "getItems",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "onTriggerKeyDown",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "open",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "openActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "close",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "closeActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isControlled",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "getItemProps",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "props",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				},
				{
					"name": "scope",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "itemOnClick",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "item",
					"type": {
						"name": "signature",
						"type": "object",
						"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: SyntheticEvent<>) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: React$Node,\n  text?: React$Node,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
						"signature": {
							"properties": [
								{
									"key": "iconEnd",
									"value": {
										"name": "React$Element",
										"elements": [
											{
												"name": "unknown"
											}
										],
										"raw": "React$Element<*>",
										"required": false
									}
								},
								{
									"key": "iconStart",
									"value": {
										"name": "React$Element",
										"elements": [
											{
												"name": "unknown"
											}
										],
										"raw": "React$Element<*>",
										"required": false
									}
								},
								{
									"key": "disabled",
									"value": {
										"name": "boolean",
										"required": false
									}
								},
								{
									"key": "divider",
									"value": {
										"name": "boolean",
										"required": false
									}
								},
								{
									"key": "onClick",
									"value": {
										"name": "signature",
										"type": "function",
										"raw": "(event: SyntheticEvent<>) => void",
										"signature": {
											"arguments": [
												{
													"name": "event",
													"type": {
														"name": "SyntheticEvent",
														"elements": [],
														"raw": "SyntheticEvent<>"
													}
												}
											],
											"return": {
												"name": "void"
											}
										},
										"required": false
									}
								},
								{
									"key": "render",
									"value": {
										"name": "signature",
										"type": "function",
										"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
										"signature": {
											"arguments": [
												{
													"name": "item",
													"type": {
														"name": "Object"
													}
												},
												{
													"name": "props",
													"type": {
														"name": "Object"
													}
												},
												{
													"name": "theme",
													"type": {
														"name": "Object"
													}
												}
											],
											"return": {
												"name": "React$Element",
												"elements": [
													{
														"name": "unknown"
													}
												],
												"raw": "React$Element<*>"
											}
										},
										"required": false
									}
								},
								{
									"key": "secondaryText",
									"value": {
										"name": "React$Node",
										"required": false
									}
								},
								{
									"key": "text",
									"value": {
										"name": "React$Node",
										"required": false
									}
								},
								{
									"key": "variant",
									"value": {
										"name": "union",
										"raw": "'regular' | 'danger' | 'success' | 'warning'",
										"elements": [
											{
												"name": "literal",
												"value": "'regular'"
											},
											{
												"name": "literal",
												"value": "'danger'"
											},
											{
												"name": "literal",
												"value": "'success'"
											},
											{
												"name": "literal",
												"value": "'warning'"
											}
										],
										"required": false
									}
								}
							]
						},
						"alias": "Item"
					}
				},
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "focusTrigger",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		}
	],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": true,
			"description": "Trigger for the Dropdown"
		},
		"defaultIsOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Open the Dropdown immediately upon initialization"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disable the Dropdown"
		},
		"data": {
			"flowType": {
				"name": "Array",
				"elements": [
					{
						"name": "signature",
						"type": "object",
						"raw": "{ items: Array<Item>, title?: React$Node }",
						"signature": {
							"properties": [
								{
									"key": "items",
									"value": {
										"name": "Array",
										"elements": [
											{
												"name": "signature",
												"type": "object",
												"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: SyntheticEvent<>) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: React$Node,\n  text?: React$Node,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
												"signature": {
													"properties": [
														{
															"key": "iconEnd",
															"value": {
																"name": "React$Element",
																"elements": [
																	{
																		"name": "unknown"
																	}
																],
																"raw": "React$Element<*>",
																"required": false
															}
														},
														{
															"key": "iconStart",
															"value": {
																"name": "React$Element",
																"elements": [
																	{
																		"name": "unknown"
																	}
																],
																"raw": "React$Element<*>",
																"required": false
															}
														},
														{
															"key": "disabled",
															"value": {
																"name": "boolean",
																"required": false
															}
														},
														{
															"key": "divider",
															"value": {
																"name": "boolean",
																"required": false
															}
														},
														{
															"key": "onClick",
															"value": {
																"name": "signature",
																"type": "function",
																"raw": "(event: SyntheticEvent<>) => void",
																"signature": {
																	"arguments": [
																		{
																			"name": "event",
																			"type": {
																				"name": "SyntheticEvent",
																				"elements": [],
																				"raw": "SyntheticEvent<>"
																			}
																		}
																	],
																	"return": {
																		"name": "void"
																	}
																},
																"required": false
															}
														},
														{
															"key": "render",
															"value": {
																"name": "signature",
																"type": "function",
																"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
																"signature": {
																	"arguments": [
																		{
																			"name": "item",
																			"type": {
																				"name": "Object"
																			}
																		},
																		{
																			"name": "props",
																			"type": {
																				"name": "Object"
																			}
																		},
																		{
																			"name": "theme",
																			"type": {
																				"name": "Object"
																			}
																		}
																	],
																	"return": {
																		"name": "React$Element",
																		"elements": [
																			{
																				"name": "unknown"
																			}
																		],
																		"raw": "React$Element<*>"
																	}
																},
																"required": false
															}
														},
														{
															"key": "secondaryText",
															"value": {
																"name": "React$Node",
																"required": false
															}
														},
														{
															"key": "text",
															"value": {
																"name": "React$Node",
																"required": false
															}
														},
														{
															"key": "variant",
															"value": {
																"name": "union",
																"raw": "'regular' | 'danger' | 'success' | 'warning'",
																"elements": [
																	{
																		"name": "literal",
																		"value": "'regular'"
																	},
																	{
																		"name": "literal",
																		"value": "'danger'"
																	},
																	{
																		"name": "literal",
																		"value": "'success'"
																	},
																	{
																		"name": "literal",
																		"value": "'warning'"
																	}
																],
																"required": false
															}
														}
													]
												}
											}
										],
										"raw": "Array<Item>",
										"required": true
									}
								},
								{
									"key": "title",
									"value": {
										"name": "React$Node",
										"required": false
									}
								}
							]
						}
					}
				],
				"raw": "Array<{ items: Array<Item>, title?: React$Node }>"
			},
			"required": true,
			"description": "Data from which the [Menu](../menu#data) will be constructed (see [example](#data))"
		},
		"isOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "For use with controlled components, in which the app manages Dropdown state"
		},
		"modifiers": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "Plugins that are used to alter behavior. See [PopperJS docs](https://popper.js.org/popper-documentation.html#modifiers) for options."
		},
		"onClose": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Dropdown is closed"
		},
		"onOpen": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Dropdown is opened"
		},
		"placement": {
			"flowType": {
				"name": "union",
				"raw": "| 'bottom-end'\n| 'bottom-start'\n| 'left-end'\n| 'left-start'\n| 'right-end'\n| 'right-start'\n| 'top-end'\n| 'top-start'",
				"elements": [
					{
						"name": "literal",
						"value": "'bottom-end'"
					},
					{
						"name": "literal",
						"value": "'bottom-start'"
					},
					{
						"name": "literal",
						"value": "'left-end'"
					},
					{
						"name": "literal",
						"value": "'left-start'"
					},
					{
						"name": "literal",
						"value": "'right-end'"
					},
					{
						"name": "literal",
						"value": "'right-start'"
					},
					{
						"name": "literal",
						"value": "'top-end'"
					},
					{
						"name": "literal",
						"value": "'top-start'"
					}
				]
			},
			"required": false,
			"description": "Placement of the Dropdown menu",
			"defaultValue": {
				"value": "'bottom-start'",
				"computed": false
			}
		},
		"wide": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a wider Dropdown menu"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Dropdown/Dropdown.js
// module id = 1621
// module chunks = 0